












































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'
import { snackBarState } from '../../stores/snackbar'
import { LETTER_FORMAT } from '../../utils/constants'
import { checkMobile } from '../../utils/utils'
import { UserOnboardType } from '../../../api/v2/models/user'

@Component({
  components: {
  }
})
export default class OnBoarding extends Vue {
  LETTER_FORMAT = LETTER_FORMAT
  mobile: boolean = checkMobile()

  drawer = true

  get schoolSetting() {
    return headerState.schoolSetting
  }
  get user() {
    return userState.user
  }
  get userOnboard() {
    return this.previewUserOnboard ?? this.user.userOnboard
  }
  state: 'welcome' | 'course' | 'contact_form' = 'welcome'
  async created() {
    this.drawer = !this.mobile
    headerState.setTitle('マイプロファイル')
    headerState.getSchoolSetting()

    if (this.previewCode) {
      this.previewUserOnboard = await api.userOnboard.index({ previewCode: this.previewCode })
    }

    this.state = this.$route.hash ?  this.$route.hash.replace("#", "") : 'welcome' as any
  }

  previewUserOnboard: UserOnboardType | null = null

  @Watch('user')
  watchUser() {
    if (!this.userOnboard && !this.previewCode) {
      this.$router.push({
        name: ROUTER_NAME.HOME
      })
    }
  }

  get previewCode() {
    return this.$route.query['preview_code'] as string ?? ''
  }

  onGotoWelcome() {
    this.state = 'welcome'
    this.goToState()
  }

  onGotoCourse() {
    this.state = 'course'
    this.goToState()
  }

  onGotoForm() {
    this.userOnboard.courses.forEach(item => {
      if (item.selected) {
        api.enrollment.create({
          user_id: this.user.id,
          course_id: item.id
        })
      }
    });

    (window as any).onContactFormCheckInputSuccess = () => {
      // Wait submit complete
      userState.isLoading = true
      setTimeout(async () => {
        if (this.previewUserOnboard) {
          this.$router.push({
            name: ROUTER_NAME.HOME
          })
          snackBarState.setPushSnackbar('オンボーディングプレビューが完了しました。');
        } else {
          await userState.getUser()
          this.previewUserOnboard = null
          this.$router.push({
            query: {}
          })
          if (!this.userOnboard) {
            snackBarState.setPushSnackbar('ありがとございました');
          }
        }
      }, 2000);
    }

    this.state = 'contact_form'
    this.goToState()
  }

  goToState(){
    this.$router.push({
      hash: this.state,
      query: this.$route.query
    })
  }

  goToHome() {
    this.$router.push({
      name: ROUTER_NAME.HOME
    })
  }
}
